<button (click)="processData()" mat-stroked-button color="warn">Process Data</button>
<prettyjson [obj]="mData"></prettyjson>
